import { useState } from "react";
import React from "react";
import bgimg from "../images/bgimg.png";
import plogo1 from "../images/plogo1.png";
import plogo2 from "../images/plogo2.png";
import plogo3 from "../images/plogo3.png";

export default function Section2({ section3Ref }) {
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogin = () => {
    if (!mobileNumber) {
      setError("Mobile Number is required");
    } else if (!/^\d{10}$/.test(mobileNumber)) {
      setError("Mobile Number must be exactly 10 digits");
    } else {
      setError("");
      alert(`Logging in with mobile number: ${mobileNumber}`);
    }
  };

  const handleSignup = () => {
    if (!mobileNumber) {
      setError("Mobile Number is required");
    } else if (!/^\d{10}$/.test(mobileNumber)) {
      setError("Mobile Number must be exactly 10 digits");
    } else {
      setError("");
      setIsModalOpen(true);
    }
  };

  const scrollToSection3 = () => {
    setIsModalOpen(false);
    section3Ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="relative text-white py-16 px-4 text-center min-h-screen flex flex-col items-center">
      {/* Background Covering Only Half */}
      <div
        className="absolute top-0 left-0 w-full h-1/2 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgimg})` }}
      ></div>

      {/* Content Section */}
      <div className="relative z-10 max-w-4xl mx-auto mt-16">
        <h1 className="text-3xl font-bold">Our Partners</h1>
        <br />
        <br />
      </div>

      {/* Cards Section */}
      <div className="relative z-10 w-full max-w-6xl px-6 mt-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {[
            {
              title: "Submit the details of your customers",
              icon: plogo1,
            },
            {
              title:
                "You can apply for all available pre-approved offers on behalf of the customers with their consent",
              icon: plogo2,
            },
            {
              title: "Get paid for each subscription and on loan disbursal",
              icon: plogo3,
            },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white text-black p-6 rounded-lg shadow-lg flex flex-col items-center md:flex-row md:items-start text-center md:text-left gap-4"
            >
              {/* Logo for each card */}
              <img src={item.icon} alt="Logo" className="w-12 h-12" />

              {/* Text Content */}
              <p className="text-lg font-semibold">{item.title}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Login/Signup Section */}
      <div className="relative z-10 flex flex-col md:flex-row items-center gap-3 mt-12 w-full max-w-lg">
        <span className="text-gray-700 text-sm">Already a Partner? Login</span>
        <input
          type="text"
          placeholder="Enter Mobile Number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          className="border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-black w-full md:w-auto"
        />
        <button
          onClick={handleLogin}
          className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 w-full md:w-auto"
        >
          Login
        </button>
        <span className="text-gray-500 text-sm">(Or)</span>
        <button
          onClick={handleSignup}
          className="border border-orange-500 text-orange-500 px-4 py-2 rounded-md hover:bg-orange-100 w-full md:w-auto"
        >
          Signup
        </button>
      </div>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

      {/* Signup Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-lg"
            >
              ✖
            </button>

            <div className="text-center">
              <img
                src="https://cdn-icons-png.flaticon.com/512/755/755011.png"
                alt="Warning"
                className="w-16 mx-auto"
              />
              <h2 className="text-xl font-bold text-red-500 mt-2">
                You have not registered as a partner with us
              </h2>
              <p className="text-gray-600 mt-2">
                <a href="#" className="text-orange-500 hover:underline">
                  Try again
                </a>{" "}
                with an alternative number
              </p>
              <p className="text-blue-600 font-semibold mt-2">
                New user? Click below to register
              </p>

              <button
                onClick={scrollToSection3}
                className="bg-orange-500 text-white px-6 py-2 rounded-md mt-4 hover:bg-orange-600"
              >
                Partner Signup
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
